export const parse = rawData => ({
    siteprofiler: rawData.siteprofiler,
    siteprofilerBeta: rawData.siteprofiler_beta,
});
